import {
    BenchmarkingBasis,
    BenchmarkingDisplay,
    BenchmarkingReportSettings,
} from '@/hooks'
import { RadioOptionPicker } from '../RadioOptionPicker/RadioOptionPicker'
import { Option } from '../types'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

type BasisSelectProps = {
    reportSettings: BenchmarkingReportSettings
    value: BenchmarkingBasis
    onChange: (type: BenchmarkingBasis) => void
}

export const BasisSelect: React.FC<BasisSelectProps> = (props) => {
    const { reportSettings, value, onChange } = props
    const { t } = useTranslation('translations')

    const options = useMemo(() => {
        const options: Array<Option<BenchmarkingBasis>> = [
            {
                value: 'usage',
                label: t('analytics.benchmarking.basis.usage'),
            },
            {
                value: 'cost',
                label: t('analytics.benchmarking.basis.cost'),
            },
            {
                value: 'costPerUsage',
                label: t('analytics.benchmarking.basis.costPerUsage'),
            },
        ]

        const displayOptionsWithNoEmission: Array<BenchmarkingDisplay> = [
            'node',
            'usn',
            'meter',
        ]

        if (!displayOptionsWithNoEmission.includes(reportSettings.display)) {
            options.push({
                value: 'emission',
                label: t('analytics.benchmarking.basis.emissions'),
            })
        }

        return options
    }, [reportSettings.display, t])

    return (
        <RadioOptionPicker
            name="basis-type"
            label={t('analytics.benchmarking.basis.label')}
            value={value}
            options={options}
            onChange={(value: string) => {
                onChange(value as BenchmarkingBasis)
            }}
            renderLabel={(option) => {
                return (
                    <div className="flex flex-col">
                        <div className="text-label-small text-regular">
                            {option.label}
                        </div>
                    </div>
                )
            }}
        />
    )
}
